import React, { useEffect, useState } from 'react';
import { Collapsed } from '../../model/Collapsed';
import { Pagination } from '../Pagination';
import { t } from '../../i18n';

const ListBlock = ({ title, viewMoreLabel, icon, color, items, selected, expanded, onCheck, onExpand }: Props) => {
  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [ items.length ]);
  
  const getItems = () => {
    if(!expanded) {
      return items.slice(0, 2);
    }
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return items.slice(indexOfFirstItem, indexOfLastItem);
  }

  if(items.length) {
    const pageItems = getItems();
    return (
      <div>
        <div style={{ height: expanded ? 350 : 'auto' }}>
          <div className="border-bottom pt-4 pb-4 list-title">{title} ({items.length})</div>
          {
            pageItems.map(i => <div key={i.id} className="d-flex border-bottom pt-3 pb-3">
              <input type="checkbox" className="form-check-input" checked={selected.includes(i.id)} onChange={(e) => onCheck(i, e.target.checked)} />
              <span className={`ti ti-sm ms-2 ti-${icon} text-${color}`}></span>
              <div className="flex-grow-1 ms-2">{i.name}</div>
            </div>)
          }
          {
            !expanded &&
              <div className="pt-3 pb-3 border-bottom">
                <a className="view-more text-capitalize text-decoration-underline" onClick={onExpand}>{viewMoreLabel}</a>
              </div>
          }
        </div>
        {
          expanded ? 
            <div className="mt-4 w-100 d-flex align-items-center">
              <small className="text-start text-muted">{t('common.showingItems', { shown: itemsPerPage > items.length ? items.length : itemsPerPage, total: items.length })}</small>
              <div className="flex-grow-1 d-flex justify-content-end">
                <Pagination itemsPerPage={itemsPerPage} totalItems={items.length} page={currentPage} onChange={setCurrentPage} />
              </div>
            </div> : ''
        }
      </div>
    );
  }
  return null;
}

interface Props {
  title: string,
  viewMoreLabel: string,
  icon: string,
  color: string,
  items: Collapsed[],
  selected: string[],
  expanded: boolean,
  onCheck: (item: Collapsed, value: boolean) => void,
  onExpand: () => void
}

export { ListBlock };